import { render, staticRenderFns } from "./AttendanceDetails.vue?vue&type=template&id=519a6d9a&scoped=true"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js"
import style0 from "./AttendanceDetails.vue?vue&type=style&index=0&id=519a6d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a6d9a",
  null
  
)

export default component.exports